import AbstractUser from "./AbstractUser";

export default class Student extends AbstractUser {

}
